<template>
    <div>
    <v-tabs
        color="secondary"
        dark
    > 
   <v-tabs-slider color="white"></v-tabs-slider>
    <v-tab @click="way='user'">
     <img :src="require('../assets/user.svg')" :width="20"/>
       &nbsp; &nbsp;Persoal Info
    </v-tab>
    <v-tab @click="way='password'">
     <img :src="require('../assets/password.svg')" :width="20"/>
       &nbsp; &nbsp;Change Password
    </v-tab>
    <v-tab @click="way='manageupi'">
     <img :src="require('../assets/pay.svg')" :width="20"/>
       &nbsp; &nbsp;Manage UPI
    </v-tab>
    </v-tabs>
    <Userinfo  v-show="way=='user'"/>
    <ChangePassword v-show="way=='password'" />
    <ManageUPI v-show="way=='manageupi'" />
  </div>            
 

</template>
<script>
import ChangePassword from '../settings/ChangePassword.vue'
import Userinfo from '../settings/Userinfo.vue'
import ManageUPI from '../settings/ManageUPI.vue'
export default {
    data(){
        return{
            way:'user',
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    watch:{
        user(value){
            let vm = this;        
            if(vm.user.length==0){
                this.$router.push("/account");
            }           
        }
    },

    components:{
        Userinfo,
        ChangePassword,
        ManageUPI
    },
    mounted(){
        let vm = this;        
        if(vm.user.length==0){
            this.$router.push("/account");
        }

    }
}
</script>
